// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SubmitButton__timer-d3c651 {
  color: var(--base-80);
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChatFooter/InputPanel/SubmitButton/SubmitButton.styles.m.css"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,wBAAA;EACA,0CAAA;AACF","sourcesContent":[".timer {\n  color: var(--base-80);\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"timer": `SubmitButton__timer-d3c651`
};
module.exports = ___CSS_LOADER_EXPORT___;
